// Aprovação de gate (passagem de fase PD1→PD2…). Governança stage-gate.
// Não bloqueia o avanço — registra quem aprovou e quando (auditável).
import { supabase } from './supabase';

export interface GateApproval {
  phase: string;
  approvedByName: string | null;
  note: string | null;
  approvedAt: string;
}

export async function loadGates(productId: string): Promise<Record<string, GateApproval>> {
  const { data } = await supabase
    .from('gate_approvals')
    .select('phase, approved_by_name, note, approved_at')
    .eq('product_id', productId);
  const out: Record<string, GateApproval> = {};
  for (const r of (data ?? []) as Record<string, unknown>[]) {
    const phase = r.phase as string;
    out[phase] = {
      phase,
      approvedByName: (r.approved_by_name as string) ?? null,
      note: (r.note as string) ?? null,
      approvedAt: r.approved_at as string,
    };
  }
  return out;
}

export async function approveGate(params: {
  orgId: string;
  productId: string;
  phase: string;
  userId: string | null;
  name: string | null;
  note: string | null;
}): Promise<{ error?: string }> {
  const { error } = await supabase.from('gate_approvals').upsert(
    {
      org_id: params.orgId,
      product_id: params.productId,
      phase: params.phase,
      approved_by: params.userId,
      approved_by_name: params.name,
      note: params.note,
      approved_at: new Date().toISOString(),
    },
    { onConflict: 'product_id,phase' },
  );
  return { error: error?.message };
}

export async function revokeGate(productId: string, phase: string): Promise<{ error?: string }> {
  const { error } = await supabase
    .from('gate_approvals')
    .delete()
    .eq('product_id', productId)
    .eq('phase', phase);
  return { error: error?.message };
}
